import {SvgIcon} from '@mui/material';
import MainLinearGradient from './MainLinearGradient';

export default function PrayServiceIcon(props: { color?: string; }) {
	const {color = 'url(#paint0_linear_1074_1969)'} = props;
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none">
			<path opacity="0.4"
			      d="M16 7.06672V28.4401C16.2267 28.4401 16.4667 28.4 16.6533 28.2934L16.7067 28.2668C19.2667 26.8668 23.7333 25.4001 26.6266 25.0134L27.0133 24.96C28.2933 24.8 29.3333 23.6001 29.3333 22.3201V6.21337C29.3333 4.6267 28.04 3.42672 26.4534 3.56005C23.6534 3.78672 19.4134 5.20008 17.04 6.68008L16.7067 6.88004C16.5067 7.00004 16.2533 7.06672 16 7.06672Z"
			      fill={color}/>
			<path
				d="M2.6665 6.22665V22.32C2.6665 23.6 3.70649 24.8 4.98649 24.96L5.42651 25.0134C8.33318 25.4 12.8132 26.88 15.3732 28.2933C15.5465 28.4 15.7598 28.44 15.9998 28.44V7.06666C15.7465 7.06666 15.4931 6.99997 15.2931 6.87997L15.0665 6.73332C12.6932 5.23999 8.43981 3.81333 5.63981 3.57333H5.55981C3.97315 3.44 2.6665 4.62665 2.6665 6.22665Z"
				fill={color}/>
			<path
				d="M25.3333 3.70667V9.42664C25.3333 9.95997 24.7466 10.2799 24.2933 9.98661L22.6667 8.90662L21.04 9.98661C20.6 10.2799 20 9.95997 20 9.42664V5.2266C21.7467 4.53327 23.6933 3.97333 25.3333 3.70667Z"
				fill={color}/>
			<defs>
				<linearGradient id="paint0_linear_1074_1969" x1="29.0488" y1="3.54993" x2="15.3352" y2="3.92174"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
